<template>
<div>

</div>
</template>

<script>
export default {
    name: 'map-about',
}
</script>

<style lang="less">
@import '../../less/variables';


</style>
